import { EMPTY_STRING } from "../../../constants";

export const NO_STATUS_TEXT = "";
export const NEEDS_REVIEW_TEXT = "Needs Review";
export const NEEDS_DATA_TEXT = "Needs Data";
export const PATHOLOGY_ENTRY_REQUESTED_TEXT = "Pathology Entry in Progress";
export const CEM_GENERATED_TEXT = "Generated";
export const CEM_FAILED_TEXT = "Error";
export const INELIGIBLE_TEXT = "Ineligible";
export const READY_FOR_PATHOLOGY_ENTRY_TEXT = "Ready for Pathology Entry";

export const planStageEnum = {
    NO_STATUS: 0,
    NEEDS_REVIEW: 1,
    NEEDS_DATA: 2,
    PATHOLOGY_ENTRY_IN_PROGRESS: 3,
    CEM_GENERATED: 4,
    CEM_FAILED: 5,
    INELIGIBLE: 6,
    READY_FOR_PATHOLOGY_ENTRY: 7,
};

const planStageMessages = {
    NO_STATUS: EMPTY_STRING,
    NEEDS_REVIEW: "Marked for Review on:",
    NEEDS_DATA: EMPTY_STRING,
    PATHOLOGY_ENTRY_REQUESTED: "Requested on:",
    CEM_GENERATED: "CEM Generated on:",
    CEM_FAILED: "CEM Failed to Generate on:",
    INELIGIBLE: "Marked Ineligible on:",
    READY_FOR_PATHOLOGY_ENTRY: "Ready for Entry on:",
};

const defaultPlanStageMessage = EMPTY_STRING;

export const planStageTooltipMsg = Object.keys(planStageEnum)
    .sort((a, b) => planStageEnum[a] - planStageEnum[b])
    .map((key) => planStageMessages[key] || defaultPlanStageMessage);

export const AUTO_PLAN_STAGES = [
    planStageEnum.NO_STATUS,
    planStageEnum.NEEDS_DATA,
    planStageEnum.READY_FOR_PATHOLOGY_ENTRY,
];
